// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#page-content-wrapper[data-v-2bb8fab5]{overflow-y:hidden}", "",{"version":3,"sources":["webpack://./resources/assets/js/pages/project/activities/kanban.vue"],"names":[],"mappings":"AACA,uCACE,iBAAF","sourcesContent":["\n#page-content-wrapper {\n  overflow-y: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
